import { Navigate, Outlet } from "react-router-dom"
import { hasSubscriptionAccess } from "@/lib/billing-access"
import { useSession } from "@/lib/session-context"

export function SubscriptionGate() {
  const { currentUser } = useSession()

  if (!currentUser) return <Navigate to="/sign-in" replace />
  if (!hasSubscriptionAccess(currentUser)) return <Navigate to="/billing" replace />

  return <Outlet />
}
